import React, { Component } from "react";
import { connect } from "react-redux";
import PageHeader from '../common/PageHeader';
//import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
//import Select from '@material-ui/core/Select';
//import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import AppContainer from "../common/AppContainer";
import * as authActions from "../auth/actions"; 

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
});

function handleSubmitfunc(event) {
    fetch('/', {
        method: 'POST',
        body: new FormData(event.target)
    });
}

class PumpTestForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded:false,
            item: []
        };
        this.handleSubmit = handleSubmitfunc.bind(this);
    }
    
    render() {
        const { isEdit, item } = this.state;
        const { authState } = this.props; // authState seems to be here by magic! :-) //navigation
        if (!authState) return "...";        
        if (!isEdit) {
            this.setState({id: "new"});
        } 
        return (
            <AppContainer authenticated>
                <PageHeader title={item.well_id + ' Pump Test Entry '} />
                <form onSubmit={this.handleSubmit}>
                    <Input type="hidden" value={this.state.id} id="id" />
                    <TextField
                        id="date"
                        label="Date"
                        type="date"
                    />
                    <TextField
                        id="testedby"
                        label="Performed By"
                    />
                    <TextField
                        id="flowrate"
                        label="Flow Rate (GPM)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="afday"
                        label="Af/Day (Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="staticwater"
                        label="Static Water Level (ft)"
                        type="number"
                    />
                    <TextField
                        id="pumpingwater"
                        label="Pumping Water Level"
                        type="number"
                    />
                    <TextField
                        id="discharge"
                        label="Discharge Level Above Pipe (ft)"
                        type="number"
                    />
                    <TextField
                        id="tdh"
                        label="TDH (does not include Hf/Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="motorhorsepower"
                        label="Horsepower (HP)"
                        type="number"
                    />
                    <TextField
                        id="waterhorsepower"
                        label="Water Horsepower (HP / Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="horsepower"
                        label="Horsepower Input (HP)"
                        type="number"
                    />
                    <TextField
                        id="kilowatt"
                        label="Kilowatt Hour Input (kW-hr / Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="kwhr"
                        label="kW-hr / AF-day (Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="specificcapacity"
                        label="Specific Capacity (GMP/ft-DD / Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <TextField
                        id="efficiency"
                        label="Efficiency (% / Auto-Calculated)"
                        disabled
                        type="number"
                    />
                    <button type="submit">Submit</button>
                </form>
            </AppContainer>
        );
    }
}
PumpTestForm = connect(
    state => ({ authState: state.auth }),
    {
        ...authActions
    }
)(PumpTestForm);

export default withStyles(styles)(PumpTestForm); 
